import { SidebarMenuSub } from '@/components/ui/sidebar';
import { cn } from 'src/lib/utils';

const SidebarAppsList = ({ className, ...props }: React.ComponentProps<typeof SidebarMenuSub>) => (
  <SidebarMenuSub
    className={cn('mx-0 flex-1 translate-x-0 overflow-y-auto border-l-0 px-0 py-1 contain-size', className)}
    {...props}
  />
);

export default SidebarAppsList;
